import { useSharePrices } from 'hooks/vault/useSharePrices'
import LineChart from './LineChart'

const SharePriceChart = () => {
  const data = useSharePrices()
  return (
    <div className="h-full px-6">
      <div className="my-6 px-6 text-2xl font-semibold text-th-fgd-1">
        Share Price Chart
      </div>
      <LineChart data={data} lineKey="price" xAxisKey="date" />
    </div>
  )
}

export default SharePriceChart
